/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const DEFAULT_DECIMAL_PLACES = 2;
export const DEFAULT_DECIMAL_PLACES_STR = `${DEFAULT_DECIMAL_PLACES}`;
